//主页面
// const index = r => require.ensure([], () => r(require('@/components/home.vue')), 'index');
const index = () => import(/* webpackChunkName:'grounp' */ '@/components/home.vue');

//策略合同分配表
const strategicContractList = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/futuresStrategy/strategicContract/list.vue');

//新增策略合同分配
const strategicContractAdd = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/futuresStrategy/strategicContract/add.vue');

//策略合同分配详情
const strategicContractDetail = () =>
  import(/* webpackChunkName:'grounp' */ '@/pages/futuresStrategy/strategicContract/detail.vue');

const futuresStrategyRouter = {
  path: '/futuresStrategy',
  component: index,
  children: [
    {
      path: 'strategicContractList',
      name: 'strategicContractList',
      component: strategicContractList,
      meta: {
        keepAlive: true,
        title: '策略合同分配',
      },
    },
    {
      path: 'strategicContractAdd',
      name: 'strategicContractAdd',
      component: strategicContractAdd,
      meta: {
        keepAlive: true,
        title: '新增策略合同分配',
      },
    },
    {
      path: 'strategicContractDetail',
      name: 'strategicContractDetail',
      component: strategicContractDetail,
      meta: {
        keepAlive: true,
        title: '策略合同分配详情',
      },
    },
  ],
};
export default futuresStrategyRouter;
